<template>

    <AjanlatBase :titleExtra="titleExtra"  v-if="aegonCsaladiVisible() || cegcsoportVisible()">

        <v-form  slot="biztositoi-adatok" ref="ajanlat-adatok">

            <v-layout row wrap>

                <BnFormField v-if="aegonCsaladiVisible()" :attributes="aegoncsaladi_azon" />

                <BnFormField v-if="cegcsoportVisible()" :attributes="wabard_cegcsoport" />

            </v-layout>

        </v-form>

    </AjanlatBase>

</template>

<script>
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import offerData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/OfferData';
import AjanlatBase from '../KGFBAjanlatBase.vue';
import { listTypes } from '../../../../../../../../modules/List';

export default {
    name: 'AjanlatAdatokB16_V0',
    mixins: [offerData],
    components: {
        AjanlatBase,
        BnFormField,
    },
    methods: {
        aegonCsaladiVisible() {
            return this.kedvezmenyek.biztkozvetitoi === true;
        },
        cegcsoportVisible() {
            return this.kedvezmenyek.kiemeltpartner === true;
        },
    },
    data() {
        return {
            aegoncsaladi_azon: {
                type: 'text',
                label: 'MNB regisztrációs azonosító',
                visible: true,
                editable: true,
                help: true,
                mezo: 'aegoncsaladi_azon',
                path: 'tarifaData.aegoncsaladi_azon',
                rules: [],
            },
            wabard_cegcsoport: {
                type: 'select',
                label: 'Cégcsoport kedvezmény (cég)',
                visible: true,
                editable: true,
                help: true,
                mezo: 'wabard_cegcsoport',
                path: 'tarifaData.wabard_cegcsoport',
                rules: [],
                itemsText: 'value',
                itemsValue: 'key',
                resource: listTypes.waberer_ceg,
            },
        };
    },
};
</script>
